import { connect } from 'react-redux';
import { PANTALLA_LIBRO_ID } from '../../constantes';
import Paginacion from '../../paginacion';
import { getNumPaginaIzquierda, getPrimeraPagina, getUltimaPagina } from '../../selectors/config-libro';
import { getConfigGeneral } from '../../selectors';
import { pantalla } from '../../actions';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var numPagina = getNumPaginaIzquierda(state, ownProps.libroId, ownProps.numPagina);
  var incremento = 2;
  var separador = getConfigGeneral(state).separadorPaginacion || ' of ';
  return {
    primeraPagina: getPrimeraPagina(state, ownProps.libroId),
    ultimaPagina: getUltimaPagina(state, ownProps.libroId),
    incremento: incremento,
    numPagina: numPagina,
    separador: separador
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onPagina: function onPagina(numPagina) {
      return dispatch(pantalla(PANTALLA_LIBRO_ID, {
        libroId: ownProps.libroId,
        numPagina: numPagina
      }));
    }
  };
};

var PaginacionContainer = connect(mapStateToProps, mapDispatchToProps)(Paginacion);
export default PaginacionContainer;